module.exports = __webpack_public_path__ + "img/hart.16b61478.png";